import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import LazyLoad from 'react-lazyload';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { ImagePlaceholder } from 'Components/frameworks/image-placeholder/ImagePlaceholder';
import { getVideoUrl, isVideoUrl } from './Video.utils';
export type VideoProps = {
  className?: string;
  iFrameClassName?: string;
  ratioKey?: string;
  url: string;
};
export function Video(props: VideoProps) {
  const { className, iFrameClassName, ratioKey = ratioUtils.L, url } = props;

  if (!isVideoUrl(url)) {
    return null;
  }

  return (
    <ImagePlaceholder aspectRatio={100 * ratioUtils.VALUES[ratioKey]} className={className}>
      <LazyLoad
        className="flex h-full items-center justify-center overflow-hidden rounded-12 bg-cover bg-center bg-no-repeat leading-0"
        once
        offset={100}
      >
        <iframe
          loading="lazy"
          title="Video iframe"
          className={classnames(
            iFrameClassName,
            'animation-duration-500 lazy h-[54vw] max-h-full w-[96vw] animate-fadeIn border-0',
          )}
          src={getVideoUrl(url)}
          allowFullScreen
        />
      </LazyLoad>
    </ImagePlaceholder>
  );
}
